/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Components */
import {parseDataToProps} from "../helpers";

const productFilterOverviewNodes = document.querySelectorAll('.product-filter-overview');

if (productFilterOverviewNodes.length > 0) {
    import(/* webpackChunkName: "ProductFilterOverview" */ './ProductFilterOverview').then(({default: ProductFilterOverview}) => {
        [...productFilterOverviewNodes].forEach((node) => render(
            <ProductFilterOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
